import React, { Key, ReactNode } from 'react';
import { CheckboxOptionType } from 'antd';
import { CirclesFour, Kanban, MagicWand, Target, Truck, ChartPie } from 'common/svg';
import { IPurchaseOrderStoreModel } from 'entities/PurchaseOrder/PurchaseOrder.models';
import { ITrackStoreMetric, ITrackStoreStore } from 'entities/TrackStore/TrackStore.models';
import { IMonitorSalesStore } from 'entities/MonitorSales/MonitorSales.models';

export interface ICheckTokenData extends Components.Schemas.CheckTokenDto {}

export enum ECommonFormType {
  Add = 'add',
  Update = 'update',
}

export enum EDaysShort {
  Mon = 'mon',
  Tue = 'tue',
  Wed = 'wed',
  Thu = 'thu',
  Fri = 'fri',
  Sat = 'sat',
  Sun = 'sun',
}

export const weekDaysOptionsShort: CheckboxOptionType<EDaysShort>[] = [
  { label: 'Mon', value: EDaysShort.Mon },
  { label: 'Tue', value: EDaysShort.Tue },
  { label: 'Wed', value: EDaysShort.Wed },
  { label: 'Thu', value: EDaysShort.Thu },
  { label: 'Fri', value: EDaysShort.Fri },
  { label: 'Sat', value: EDaysShort.Sat },
  { label: 'Sun', value: EDaysShort.Sun },
];

export const weekDaysOptionsFull: CheckboxOptionType<EDaysShort>[] = [
  { label: 'Monday', value: EDaysShort.Mon },
  { label: 'Tuesday', value: EDaysShort.Tue },
  { label: 'Wednesday', value: EDaysShort.Wed },
  { label: 'Thursday', value: EDaysShort.Thu },
  { label: 'Friday', value: EDaysShort.Fri },
  { label: 'Saturday', value: EDaysShort.Sat },
  { label: 'Sunday', value: EDaysShort.Sun },
];

export enum ESidebarMenuKey {
  Dashboard = 'dashboard',
  PurchaseOrder = 'purchase-order',
  GeneratePO = 'generate-po',
  TrackPO = 'track-po',
  ViewDeliveryHistory = 'view-delivery-history',
  TrackStoreRealTime = 'track-store-real-time',
  StockReconciliation = 'stock-reconciliation',
  MonitorSales = 'monitor-sales',
}

export enum ESidebarMenuLabel {
  'dashboard' = 'Dashboard',
  'purchase-order' = 'Purchase Order',
  'generate-po' = 'Generate PO',
  'track-po' = 'Track PO Real-Time',
  'view-delivery-history' = 'View Delivery History',
  'track-store-real-time' = 'Track Store Real-Time',
  'stock-reconciliation' = 'Stock Reconciliation',
  'monitor-sales' = 'Monitor Sales',
}

export const sidebarMenuIcons: { [key: string]: ReactNode } = {
  [ESidebarMenuKey.GeneratePO]: <MagicWand />,
  [ESidebarMenuKey.TrackPO]: <Kanban />,
  [ESidebarMenuKey.ViewDeliveryHistory]: <Truck />,
  [ESidebarMenuKey.TrackStoreRealTime]: <CirclesFour />,
  [ESidebarMenuKey.StockReconciliation]: <Target />,
  [ESidebarMenuKey.MonitorSales]: <ChartPie />,
};

export enum EUpdateStatus {
  Saving = 'saving',
  Saved = 'saved',
}

export interface IKanbanBoardDataSourceItem<T> {
  key: Key;
  title: string;
  items: T[];
}

export interface IOption {
  label: ReactNode;
  value?: string | number;
}

export type Store = IPurchaseOrderStoreModel | ITrackStoreStore | IMonitorSalesStore;

export type Metric = ITrackStoreMetric;

export enum EMetricType {
  Sales = 'sales',
  TransactionCount = 'transactionCount',
  AverageCheck = 'averageCheck',
  MaxQueuePerHour = 'maxQueuePerHour',
  ServedOnTime = 'servedOnTime',
}

export enum EMetricTypeLabel {
  sales = 'Sales',
  transactionCount = 'TC',
  averageCheck = 'AC',
  maxQueuePerHour = 'Max queue/hr',
  servedOnTime = 'Served on time',
}
